import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReportRecipient } from '@app/interfaces/lm/report-schedules';
import { environment } from '@env/environment';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReportingService {
    private moduleApi = environment.api.services.lm;
    private baseUrl = this.moduleApi + '/reporting';

    constructor(private http: HttpClient) {}

    async projectReporting(data: {projectId: string, recipients: string[]}): Promise<void> {
        return lastValueFrom(this.http.post<void>(`${this.baseUrl}/project`, data));
    }

    async projectGroupReporting(data: {projectGroupId: string, recipients: string[]}): Promise<void> {
        return lastValueFrom(this.http.post<void>(`${this.baseUrl}/project-group`, data));
    }

    async getProjectReportRecipients(params: { projectId: string }): Promise<ReportRecipient[]> {
        return lastValueFrom(this.http.get<ReportRecipient[]>(`${this.baseUrl}/project/recipients`, {
            params: Object.assign(params)
        }));
    }

    async getProjectGroupRecipients(params: { projectGroupId: string }): Promise<ReportRecipient[]> {
        return lastValueFrom(this.http.get<ReportRecipient[]>(`${this.baseUrl}/project-group/recipients`, {
            params: Object.assign(params)
        }));
    }
}
